import styled from 'react-emotion'

export default styled('span')`
  font-weight: 500;
`
